import {Observable} from 'rxjs';

import {take, map} from 'rxjs/operators';
import {Injectable, Injector, OnInit} from '@angular/core';
import {Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {SecurityService} from '../services/SecurityService';
import {User} from '../services/api.client';
import {SystemService} from '../services/SystemService';

@Injectable()
export class AuthGuard {

    user$: Observable<User>;
    user: User;

    constructor(
        private inject: Injector,
        private systemService: SystemService,
        private _securityService: SecurityService) {
        this.user$ = this._securityService.currentUser$;
        this.user$.subscribe(user => this.user = user);
    }

    canActivate(route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean> {
        const service: SecurityService = this.inject.get(SecurityService);
        const router: Router = this.inject.get(Router);
        // The session is rehydrated from /me before routing starts (APP_INITIALIZER in
        // routes.ts), so by the time this guard runs the in-memory user is already
        // populated for a valid cookie session. No in-memory user => no valid session
        // => redirect to /login (the old persisted-localStorage fallback is gone).
        return this.user$.pipe(
            take(1),
            map((user) => {
                if (user) {
                    return true;
                }
                service.redirectUrl = state.url;
                router.navigate(['/login']).then();
                return false;
            }));
    }

}
